
import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { User, UserDetail, DesignatedDoctorInformation } from "../../../../domain/user";

@Component({
})
export default class UserDetailMixin extends Mixins() {
  @Prop({ default: null })
  user: User;

  data(): any {
    return {
      loading: false,
      viewUser: null as User,
      viewDetail: null as UserDetail,
      isEdittingComment: false,
      edittingComment: "",
      savingComment: false,
    };
  }
  loading: boolean;
  viewUser: User;
  viewDetail: UserDetail;
  isEdittingComment: boolean;
  edittingComment: string;
  savingComment: boolean;

  get isSelected(): boolean {
    return !!this.viewUser;
  }

  get id(): string {
    return this.viewUser
      ? this.viewUser.id
      : "";
  }

  get name(): string {
    return this.viewUser
      ? this.viewUser.name
      : "";
  }

  get kanaName(): string {
    return this.viewUser
      ? this.viewUser.kanaName
      : "";
  }

  get designatedDoctorNos(): DesignatedDoctorInformation[] {
    return this.viewDetail
      ? this.viewDetail.designatedDoctorNos
      : [];
  }

  get hasDesignatedDoctorNos(): boolean {
    return (0 < this.designatedDoctorNos.length);
  }

  get email(): string {
    return this.viewUser
      ? this.viewUser.email
      : "";
  }

  get phone(): string {
    return this.viewUser
      ? this.viewUser.phone
      : "";
  }

  get comment(): string {
    return this.viewDetail
      ? this.viewDetail.comment
      : "";
  }

  get updateInformation(): string {
    return this.comment
      ? "最終更新：" + this.viewDetail.updateUserName + "　" + this.viewDetail.updateDateTime
      : "";
  }

  mounted(): void {
    if (!!this.user) {
      this.updateUserDetail();
    }
  }

  @Watch("user")
  onUserCodeUpdated(newValue: User, oldValue: User): void {
    this.updateUserDetail();
  }

  updateUserDetail(): void {
    this.loading = true;
    this.viewUser = null;  // ユーザ変更時に前の表示が残ってるのはマズいので消す.
    this.viewDetail = null;  // ユーザ変更時に前の表示が残ってるのはマズいので消す.
    this.onEdittingChanged(false);
    this.savingComment = false;
    if (!this.user) {
      this.loading = false;
      return;
    }
    const user = this.user;
    const repository = DomainRegistry.user.getUserRepository();
    repository.getUserDetail(user.id)
      .then(e => {
        if (this.user !== user) {
          return;
        }
        this.loading = false;
        this.viewUser = user;
        this.viewDetail = e;
      })
      .catch(e => {
        this.$error(
          "職員詳細情報取得失敗",
          "職員詳細情報を取得できませんでした。",
          e,
        );
        this.loading = false;
      });
  }

  editComment(): void {
    this.edittingComment = this.comment.slice();
    this.onEdittingChanged(true);
  }

  saveComment(): void {
    this.savingComment = true;
    const repository = DomainRegistry.user.getUserRepository();
    repository.setUserComment(this.id, this.edittingComment)
      .then(() => {
        this.loading = true;
        repository.getUserDetail(this.id)
          .then(e => {
            this.viewDetail = e;
          })
          .catch(e => {
            this.$error(
              "職員詳細情報取得失敗",
              "職員詳細情報を取得できませんでした。",
              e,
            );
          })
          .finally(() => {
            this.loading = false;
          });
      })
      .catch(e => {
        this.$error(
          "ユーザコメント保存失敗",
          "ユーザコメントを保存できませんでした。",
          e,
        );
      })
      .finally(() => {
        this.savingComment = false;
        this.onEdittingChanged(false);
      });
  }

  cancelComment(): void {
    this.onEdittingChanged(false);
  }

  @Emit("editting-changed")
  onEdittingChanged(value: boolean): void {
    this.isEdittingComment = value;
  }
}
